import React from 'react'
import { appUrls }  from '../utils/authService';

const Logout = () => {
   
    function getParameterByName(name, url = document.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return 'none';
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var appName = getParameterByName('appName');

    var logoutRedirectUrl;
    appUrls(appName).then((response) => {
        logoutRedirectUrl = response.data.logoutUrl;
    });  
    var iframstyle = {
        width: 0,
        height: 0,
        border: 0,
        border: 'none',
        position: 'absolute'
    }

    setTimeout(() => { document.location.href = logoutRedirectUrl; }, 2000);
    return <div>
        <h3>Logging out.......</h3>
        <iframe style={iframstyle} src={process.env.REACT_APP_LOGOUT } />
    </div>;   
};

export default Logout;